export const normalizeEnem = (data: any) => {
  if(data) {
    const {
      competencia_1_nota,
      competencia_1_comentario,
      competencia_2_nota,
      competencia_2_comentario,
      competencia_3_nota,
      competencia_3_comentario,
      competencia_4_nota,
      competencia_4_comentario,
      competencia_5_nota,
      competencia_5_comentario,
      ...oldData
    } = data

    const scores = {
      competencia_1_nota,
      competencia_1_comentario,
      competencia_2_nota,
      competencia_2_comentario,
      competencia_3_nota,
      competencia_3_comentario,
      competencia_4_nota,
      competencia_4_comentario,
      competencia_5_nota,
      competencia_5_comentario
    }

    oldData.scores = scores

    return oldData
  }

  return {}
};

export const normalizeGenres = (data: any) => {
  const { 
    adequacao_proposta,
    adequacao_proposta_comment,
    coerencia_e_coesao,
    coerencia_e_coesao_comment,
    informatividade_e_argumentacao_ou_narrativa,
    informatividade_e_argumentacao_ou_narrativa_comment,
    escrita_padrao,
    escrita_padrao_comment,
    ...oldData
  } = data
      
  const scores = {
    adequacao_proposta,
    adequacao_proposta_comment,
    coerencia_e_coesao,
    coerencia_e_coesao_comment,
    informatividade_e_argumentacao_ou_narrativa,
    informatividade_e_argumentacao_ou_narrativa_comment,
    escrita_padrao,
    escrita_padrao_comment,
  }

  oldData.scores = scores;

  return oldData;
}

//TODO: Update para novas criterias
export const normalizeFuvest = (data: any) => {
  const { 
    competencia_1_nota,
    competencia_1_comentario,
    competencia_2_nota,
    competencia_2_comentario,
    competencia_3_nota,
    competencia_3_comentario,
    competencia_4_nota,
    competencia_4_comentario,
    ...oldData
  } = data

  const scores = {
    competencia_1_nota,
    competencia_1_comentario,
    competencia_2_nota,
    competencia_2_comentario,
    competencia_3_nota,
    competencia_3_comentario,
    competencia_4_nota,
    competencia_4_comentario,
  }

  oldData.scores = scores;

  return oldData
}

export const normalizeOldFuvest = (data: any) => {
  const { 
    development_and_organization,
    development_and_organization_comment,
    coherence_and_articulation,
    coherence_and_articulation_comment,
    grammatical_correction,
    grammatical_correction_comment,
    ...oldData
  } = data

  const scores = {
    development_and_organization,
    development_and_organization_comment,
    coherence_and_articulation,
    coherence_and_articulation_comment,
    grammatical_correction,
    grammatical_correction_comment,
  }

  oldData.scores = scores;

  return oldData
}

export const normalizeUnesp = (data: any) => {
  const { 
    tema,
    tema_comment,
    genero_tipo_de_texto_e_coerencia,
    genero_tipo_de_texto_e_coerencia_comment,
    elementos_linguisticos,
    elementos_linguisticos_comment,
    coesao,
    coesao_comment,
    ...oldData
  } = data

  const scores = {
    tema,
    tema_comment,
    genero_tipo_de_texto_e_coerencia,
    genero_tipo_de_texto_e_coerencia_comment,
    elementos_linguisticos,
    elementos_linguisticos_comment,
    coesao,
    coesao_comment,
  }

  oldData.scores = scores;

  return oldData
}

export const normalizeUnicamp = (data: any) => {
  const { 
    proposta_tematica,
    proposta_tematica_comment,
    genero,
    genero_comment,
    leitura_dos_textos,
    leitura_dos_textos_comment,
    convencoes_da_escrita_e_coesao,
    convencoes_da_escrita_e_coesao_comment,
    ...oldData
  } = data

  const scores = {
    proposta_tematica,
    proposta_tematica_comment,
    genero,
    genero_comment,
    leitura_dos_textos,
    leitura_dos_textos_comment,
    convencoes_da_escrita_e_coesao,
    convencoes_da_escrita_e_coesao_comment
  }

  oldData.scores = scores;

  return oldData
}

export const normalizeUfpr = (data: any) => {
  const { 
    adequacao_a_proposta_e_genero,
    adequacao_a_proposta_e_genero_comment,
    desenvolvimento_da_proposta,
    desenvolvimento_da_proposta_comment,
    linguagem,
    linguagem_comment,
    ...oldData
  } = data

  const scores = {
    adequacao_a_proposta_e_genero,
    adequacao_a_proposta_e_genero_comment,
    desenvolvimento_da_proposta,
    desenvolvimento_da_proposta_comment,
    linguagem,
    linguagem_comment
  }

  oldData.scores = scores;

  return oldData
}

export const verifyType = (scores: any, banca: number, isOld?: boolean) => {
  //Fuvest
  if(banca === 3 && !isOld) {
    if(
      scores.competencia_1_comentario ||
      scores.competencia_2_comentario ||
      scores.competencia_3_comentario ||
      scores.competencia_4_comentario
    ) {
      return true;
    } else {
      return false;
    }
  }

  if(banca === 3 && isOld) {
    if(
      scores.development_and_organization_comment || 
      scores.coherence_and_articulation_comment || 
      scores.grammatical_correction_comment
    ){
      return true;
    } else {
      return false;
    }
  }

  //Unesp
  if(banca === 4) {
    if(
      scores.tema_comment ||
      scores.genero_tipo_de_texto_e_coerencia_comment ||
      scores.elementos_linguisticos_comment ||
      scores.coesao_comment
    ) {
      return true;
    } else {
      return false;
    }
  }

  //Unicamp
  if(banca === 5) {
    if(
      scores.proposta_tematica_comment ||
      scores.genero_comment ||
      scores.leitura_dos_textos_comment ||
      scores.convencoes_da_escrita_e_coesao_comment
    ) {
      return true;
    } else {
      return false;
    }
  }

  //UFPR
  if(banca === 6) {
    if(
      scores.adequacao_a_proposta_e_genero_comment ||
      scores.desenvolvimento_da_proposta_comment ||
      scores.linguagem_comment
    ) {
      return true;
    } else {
      return false;
    }
  }

  //Gênero
  if(banca === 7) {
    if(
      scores.adequacao_proposta_comment ||
      scores.coerencia_e_coesao_comment ||
      scores.informatividade_e_argumentacao_ou_narrativa_comment ||
      scores.escrita_padrao_comment
    ) {
      return true;
    } else {
      return false;
    }
  }
}